import { MessageCircle } from "lucide-react";
import { waLink, PRESET } from "@/lib/whatsapp";

export const FloatingWhatsApp = ({ lang }) => {
  const msg = lang === "es" ? PRESET.generalEs : PRESET.generalEn;
  return (
    <a
      href={waLink(msg)}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-24 md:bottom-6 right-5 z-40 bg-[#25D366] hover:bg-[#1ebd5b] text-white rounded-full p-4 shadow-2xl shadow-black/40 wa-pulse hover:scale-110 transition-transform"
      data-testid="floating-whatsapp-btn"
    >
      <MessageCircle size={26} strokeWidth={2} fill="currentColor" stroke="white" />
    </a>
  );
};

export const MobileStickyCTA = ({ t, lang }) => {
  const msg = lang === "es" ? PRESET.generalEs : PRESET.generalEn;
  return (
    <div
      className="fixed bottom-0 inset-x-0 z-30 md:hidden bg-bendito-bg/95 backdrop-blur border-t border-bendito-border"
      data-testid="mobile-sticky-cta"
    >
      <div className="grid grid-cols-2 gap-2 p-3">
        <a
          href="#quote"
          className="flex items-center justify-center border border-bendito-ink text-bendito-ink font-heading tracking-[0.2em] text-sm py-3 hover:bg-bendito-ink hover:text-black transition-colors"
          data-testid="mobile-cta-quote"
        >
          {t.mobile.quote}
        </a>
        <a
          href={waLink(msg)}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center bg-bendito-orange text-black font-heading tracking-[0.2em] text-sm py-3 hover:bg-bendito-orangeDark transition-colors"
          data-testid="mobile-cta-whatsapp"
        >
          {t.mobile.whatsapp}
        </a>
      </div>
    </div>
  );
};
